module.exports = __webpack_public_path__ + "img/28Wilson.4fc92adc.png";